import { render, staticRenderFns } from "./GeneralSettingsPopup.vue?vue&type=template&id=0fb311d4&scoped=true"
import script from "./GeneralSettingsPopup.vue?vue&type=script&lang=ts"
export * from "./GeneralSettingsPopup.vue?vue&type=script&lang=ts"
import style0 from "./GeneralSettingsPopup.vue?vue&type=style&index=0&id=0fb311d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb311d4",
  null
  
)

export default component.exports